import StoryPieces from './StoryPieces.vue';

export default StoryPieces;
